import {
  alignContent,
  border,
  borderRadius,
  color,
  display,
  height,
  justifyContent,
  margin,
  maxHeight,
  padding,
  textAlign,
  width,
} from "@mui/system";
import PetcoCircularRegular from "../Fonts/PetcoCircularWeb-Regular.woff";
import PetcoCircularRegular2 from "../Fonts/PetcoCircularWeb-Regular.woff2";
import PetcoCircularRegular3 from "../Fonts/PetcoCircularWeb-Thin.woff";

export const styles = {
  main: {
    width: "100%",
    height: "100%",
    backgroundColor: "white",
  },
  header: {
    height: "10vh",
  },
  content: {
    height: "90vh",
    overflow: "hidden",
  },
  content2: {
    width: "100%",
    height: "90vh",
    paddingBottom: "10vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  content3: {
    width: "100%",
    height: "90vh",
    display: "flex",
    justifyContent: "center",
  },
  divCenter: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  backgroundLog: {
    marginTop: "0px",
    marginLeft: "0px",
    marginRight: "0px",
    marginBottom: "0px",
    flex: 1,
    position: "absolute",
    width: "100%",
    height: "100%",
    overflow: "hidden",
  },
  contenedorStyle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    backgroundColor: "rgba(255, 255, 255)",
    boxShadow: "8px 10px 5px rgba(0, 0, 0, 0.2),0  8px 5px rgba(0, 0, 0, 0.2)",
  },
  formContainer: {
    width: "80%",
    height: "90%",
  },
  contenedorStyle2: {
    width: "100%",
    maxHeight: "80%",
    overflowY: "auto",
    padding: "1% 3%",
  },
  contenedorRepo: {
    width: "50vw",
    height: "80%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "5%",
    padding: "20px",
    backgroundColor: "rgba(255, 255, 255)",
    boxShadow: "8px 10px 5px rgba(0, 0, 0, 0.2),0  8px 5px rgba(0, 0, 0, 0.2)",
    position: "relative",
    overflow: "visible",
  },

  divPedido: {
    width: "100%",
    height: "80%",
    padding: "0px 100px",
  },
  divPedido1: {
    height: "95%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  pedidoRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: "10px",
  },
  parrafoPedido: {
    fontSize: "12px",
  },
  contenedorPassStyle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    padding: "20px",
    backgroundColor: "#00205B",
    boxShadow: "8px 10px 5px rgba(0, 0, 0, 0.2),0  8px 5px rgba(0, 0, 0, 0.2)",
  },
  contenedorPassStyle2: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#00205b",
    padding: "20px",
    backgroundColor: "white",
    boxShadow: "8px 10px 5px rgba(0, 0, 0, 0.2),0  8px 5px rgba(0, 0, 0, 0.2)",
    width: "75%",
    height: "90%",
    // marginLeft: "10%",
    // marginRight: "10%",
  },
  contenedorPassStyle3: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#00205b",
    padding: "20px",
    backgroundColor: "white",
    boxShadow: "8px 10px 5px rgba(0, 0, 0, 0.2),0  8px 5px rgba(0, 0, 0, 0.2)",
    width: "75%",
    height: "90%",
    // marginLeft: "10%",
    // marginRight: "10%",
  },
  containerTablePedido: {
    width: "100%",
    height: "35%",
    overflowY: "scroll",
    boxShadow: "-3px -3px 15px 0px rgba(0, 0, 0, 0.3)",
  },
  containerTable2: {
    width: "100%",
    height: "80%",
    overflowY: "scroll",
    textAlign: "center",
    boxShadow: "-3px -3px 15px 0px rgba(0, 0, 0, 0.3)",
  },
  contenedorTable: {
    height: "30%",
    overflow: "scroll",
    backgroundColor: "rgba(255, 255, 255)",
    boxShadow: "8px 10px 5px rgba(0, 0, 0, 0.2),0  8px 5px rgba(0, 0, 0, 0.2)",
  },

  prueba: {
    display: "flex",
  },
  borderBottomTr: {
    borderBottom: "0.8px solid rgb(220, 220, 220)",
    padding: "10px 0px",
  },
  tableSize: {
    width: "90%",
  },

  container: {
    padding: " 12px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  containerPedido: {
    width: "50%",
    height: "80%",
    margin: "5%",
    padding: "30px 50px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    backgroundColor: "rgba(255, 255, 255)",
    boxShadow: "8px 10px 5px rgba(0, 0, 0, 0.2),0  8px 5px rgba(0, 0, 0, 0.2)",
    position: "relative",
    overflow: "visible",
  },
  txtPedido: {
    height: "40%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  storesPedido: {},
  containerF: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
    columnGap: "20px",
    textAlign: "left",
  },
  container1: {
    margin: "2rem",
    textAlign: "center",
  },
  /*containerTable: {
    width: "80vw",
    textAlign: "center",
    overflow: "auto",
  },*/

  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%", // Asegúrate de que este contenedor pueda expandirse al tamaño del contenedor padre
    width: "100%",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  textField: {
    marginBottom: "10px",
    width: "100%",
    backgroundColor: "white",
  },
  textField2: {
    marginBottom: "10px",
    width: "100%",
    backgroundColor: "white",
    border: "solid red 3px",
    borderRadius: "10px",
  },
  textField3: {
    marginBottom: "10px",
    width: "100%",
    backgroundColor: "white",
    borderRadius: "15px",
    color: "#00205B",
  },

  button: {
    width: "100%",
    borderRadius: "20px",
    "&:hover": {
      backgroundColor: "#ffffff",
      boxShadow: "none",
    },
  },
  /*backgroundLog: {
    marginTop: "0px",
    marginLeft: "0px",
    marginRight: "0px",
    marginBottom: "0px",
    flex: 1,
    position: "absolute",
    width: "100%",
    height: "100%",
    overflow:"hidden",
  },*/
  grid: {
    display: "flex",
    flexDirection: "column",
    height: "max-content",
  },

  title: {
    margin: "10px",
    display: "flex",
    fontWeight: "bold",
  },
  titleaux: {
    margin: "10px",
    display: "flex",
    fontWeight: "bold",
    width: "100%",
  },
  widt100: {
    width: "100%",
  },
  title2: {
    marginTop: "20px",
    display: "flex",
    fontWeight: "bold",
  },

  logo: {
    height: "10vw",
  },
  logoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "2vw",
    justifyContent: "space-between",
  },

  logoContainer2: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    marginTop: "2vw",
    justifyContent: "space-between",
  },
  infoTienda: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    justifyContent: "space-around",
  },
  infoTiendaPZ: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "row",
    textAlign: "left",
    justifyContent: "space-between",
  },
  cardsAdmin: {
    display: "flex",
    flexDirection: "column",
    padding: "2rem",
    gap: "1rem",
    alignItems: "center",
    maxWidth: "80%",
  },

  containerC: {
    margin: "2% 1%",
    textAlign: "center",
    width: "98%",
    height: "96%",
    fontSize: "12px",
    maxHeight: "100%",
    overflowY: "auto",
  },
  logoP: {
    margin: "15px",
  },

  logoPedido: {
    marginTop: "50px",
    margin: "30px 0px",
    width: "50%",
  },
  logoPet: {
    margin: "15px",
    height: "30px",
  },
  logoAn: {
    margin: "15px",
  },
  head: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: "68px",
  },
  body: {
    display: "flex",
    justifyContent: "center",
    alignItems: " center",
    flexDirection: "column",
    height: "90%",
    textAlign: "center",
  },
  textin: {
    display: "flex",
    justifyContent: "center",
    alignItems: " center",
  },
  texth: {
    display: "flex",
    justifyContent: "center",
    alignItems: " center",
    color: "#00205b",
  },

  div1: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "40vw",
  },
  reportesC: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    height: "max-content",
  },
  rep: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  s: {
    margin: "10px",
  },
  editar: {
    marginTop: "20px",
    width: "15vw",
    color: "white",
  },
  formato_div: {
    width: "80%",
    padding: "1% 0% 0.5% 0%",
    display: "grid",
    gridTemplateColumns: "30% 40% 30%",
  },
  formato_tienda: {
    color: "#00205B",
    fontSize: "1rem",
    fontWeight: "bold",
    padding: "5px",
    backgroundColor: "#EFEFEF",
  },

  repo: {
    /*display: "flex",
    flexDirection: "column",*/
    display: "grid",
    gridTemplateColumns: "25% 75%",
  },
  reportButtonSize: {
    height: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30%",
    marginTop: "20px",
    maxWidth: "100%",
  },
  reportSize: {
    width: "100%",
  },
  divform: {
    height: "90vh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "2% 0%",
  },
  reportestitle: {
    margin: "10px 0px",
    display: "flex",
    fontWeight: "bold",
    justifyContent: "center",
    textAlign: "center",
  },
  reportestitle2: {
    fontWeight: "bold",
  },
  reportestitlePedido: {
    height: "20%",
    display: "flex",
    fontWeight: "bold",
    justifyContent: "center",
    alignItems: "center",
  },
  tableStores: {
    maxHeight: "100%",
    overflowY: "auto",
  },
  goTienda: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  logoRep: {
    position: "absolute",
    bottom: "-8%" /* Distancia desde abajo */,
    right: "-15%" /* Distancia desde la derecha */,
    width: "30%",
    maxWidth: "100%",
    height: "auto",
  },
  logoRep2: {
    position: "absolute",
    bottom: "-10%" /* Distancia desde abajo */,
    right: "-10%" /* Distancia desde la derecha */,
    height: "35%",
  },
  logoPass: {
    width: "20vw",
    position: "fixed",
    right: "100px",
    bottom: "0px",
  },
  passg: {
    display: "flex",
    flexDirection: "column",
    height: "90vh",
  },
  semana: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem",
    gap: "10px",
  },
  dialoginf: {
    textAlign: "center",
  },
  noStockTable: {
    width: "100%",
  },
  logoStock: {
    width: "6vw",
    position: "fixed",
    right: "0px",
    bottom: "0px",
  },
  btntxt: {
    textAlign: "center",
    textDecoration: "none",
    color: "white",
    alignItems: "center",
    display: "flex",
  },

  head2: {
    alignItems: "center",
    fontSize: "18px",
    padding: "0%",
    gap: "5px",
    fontFamily: '"PetcoCircularRegular" ,"Montserrat"',
  },
  errorbtn: {
    marginBottom: "10px",
  },
  green: {
    border: "10px solid green",
    borderRadius: "50%",
    margin: "5px",
  },
  orange: {
    border: "10px solid orange",
    borderRadius: "50%",
    margin: "5px",
  },
  red: {
    border: "10px solid red",
    borderRadius: "50%",
    margin: "5px",
  },
  gray: {
    backgroundColor: "gray",
    border: "10px solid gray",
    borderRadius: "50%",
    margin: "5px",
  },
  containerSemaforo: {
    margin: "1rem",
    textAlign: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  GuardarP: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "-1rem",
    gap: "2rem",
    flexDirection: "row",
    alignItems: "center",
  },
  Guardarbtn: {
    marginTop: "20px",
    width: "20%",
  },
  tablaPedido: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },

  celdaPedido1: {
    width: "100%",
    height: "100px",
    maxHeight: "100px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#dcffed",
  },
  celdaPedido2: {
    width: "100%",
    height: "100px",
    maxHeight: "100px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    backgroundColor: "#dcffed",
    display: "flex",
    flexDirection: "row", // Cambiado aquí para alinear elementos horizontalmente
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "2px solid white",
  },
  divForm: {
    display: "flex",
    flexDirection: "column",
    //justifyContent: "space-between",
  },
  divPdf: {
    display: "flex",
    justifyContent: "center",
    alignItems: " center",
    flexDirection: "column",
    height: "100%",
    textAlign: "center",
    position: "relative",
  },
  btnBack: {
    position: "absolute",
    top: "5px",
    left: "10px",
  },
  pdfContainer: {
    width: "0",
    height: "0",
  },
  pdfViewer3: {
    display: "flex",
    flexDirection: "column",
    width: "80%",
    height: "70vh",
    borderRadius: "10px",
    position: "relative",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  pdfViewer2: {
    width: "80%",
    height: "75vh",
    borderRadius: "10px",
    top: "20px",
    position: "relative",
  },
  containerFirma: {
    width: "80%",
    display: "flex",
    justifyContent: "space-evenly",
    position: "relative",
    top: "-15px",
  },
  containerFormFirma: {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  divCanvas: {
    width: "100%",
    height: "80%",
    border: "3px solid gray",
    backgroundColor: "transparent",
    zIndex: 0,
  },
  btnFirma: {
    marginTop: "5px",
    width: "130px",
    backgroundColor: "gray",
    color: "white",
    fontSize: "12px",
    height: "30px",
  },
  btnPdf: {
    width: "20%",
    marginTop: "20px",
    color: "white",
    fontSize: "12px",
    height: "33px",
  },
  btnPdf21: {
    width: "20%",
    marginTop: "5px",
    color: "white",
    fontSize: "12px",
    height: "33px",
  },
  btnCorreo: {
    width: "100px",
    color: "white",
    fontSize: "12px",
    height: "40px",
    margin: "10px",
  },
  btnVer:{
backgroundColor:"transparent",
border:"none",
display:"flex",
justifyContent:"center",
alignContent:"center",
placeItems:"center"
}
};
